var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-price"},[(_vm.price > 0)?[_c('span',{staticClass:"price",class:[
        {'span_isdetail': _vm.inDetail},
        {'smallCard_price': _vm.smallCard}
      ]},[_vm._v("\n      "+_vm._s(_vm._f("currency")(_vm.price))+"\n    ")]),_vm._v(" "),_c('i',[_vm._v("/"+_vm._s(_vm.unit))])]:[_c('span',{staticClass:"price--ask"},[_vm._v("\n      现询\n    ")])]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4695d1bd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TPrice.vue
// module id = null
// module chunks = 